import { ApiUrls } from '../ApiUrls';
import { httpService } from '../..';
import { IDisplayConfig } from './displaysInterfaces';

export async function fetchDisplayConfigs(): Promise<IDisplayConfig[]> {
  try {
    const response = await httpService.get(ApiUrls.displayConfigs());
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function updateDisplayConfig(config: IDisplayConfig): Promise<IDisplayConfig> {
  try {
    const response = await httpService.post(ApiUrls.displayConfigs(), config);
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function deleteDisplayConfig(userSid: string): Promise<void> {
  try {
    await httpService.delete(ApiUrls.displayConfigs(userSid));
  } catch (e) {
    throw e;
  }
}
